<script setup lang="ts">
import type { ICard } from '~/components/entity/card'
import { LucideCheck } from 'lucide-vue-next'

const { card } = defineProps<{ card: ICard }>()
const emit = defineEmits<{
  (e: 'beneficiaries-status-change', status: boolean): void
}>()
const { t } = useI18n()

const relevantBeneficiaries = [
  { name: 'private_person', text: t('widget.card_page.beneficiaries.private_person') },
  { name: 'salaries', text: t('widget.card_page.beneficiaries.salaries') },
  { name: 'pensionary', text: t('widget.card_page.beneficiaries.pensionary') },
  { name: 'student', text: t('widget.card_page.beneficiaries.student') },
  { name: 'children', text: t('widget.card_page.beneficiaries.children') },
  { name: 'social', text: t('widget.card_page.beneficiaries.social') },
  { name: 'company', text: t('widget.card_page.beneficiaries.company') }
] as const

const activeBeneficiaries = relevantBeneficiaries.filter((opt) => card.beneficiaries[opt.name])

emit('beneficiaries-status-change', activeBeneficiaries.length > 0)
</script>

<template>
  <div class="grid grid-cols-1 gap-2 md:grid-cols-2">
    <div v-for="item in activeBeneficiaries" :key="item.name" class="flex gap-2">
      <LucideCheck class="min-w-5 text-blue-600" />
      <p>{{ item.text }}</p>
    </div>
  </div>
</template>
